export default {
  mounted() {
    const inputUrlParams = Object.entries(this.$route.query).filter(([key]) => key.includes('X-Amz'));
    const inputUrlParamsString = inputUrlParams.map(([key, value]) => `${key}=${value}`).join('&');
    if (this.$route.query.input_url) {
      // eslint-disable-next-line
      if (this.form.model.includes('video_upscale')) {
        this.duration = this.$route.query.input_duration;
        this.width = this.$route.query.input_width;
        this.height = this.$route.query.input_height;
        this.form.video = `${this.$route.query.input_url}&${inputUrlParamsString}`;
      } else if (this.form.model === 'image_face_swap') {
        this.form.targetImage = `${this.$route.query.input_url}&${inputUrlParamsString}`;
      } else {
        this.form.image = `${this.$route.query.input_url}&${inputUrlParamsString}`;
      }
    }
  },
};
